// extracted by mini-css-extract-plugin
module.exports = {"success":"styles_success__23RKm","info":"styles_info__mXpPq","warning":"styles_warning__waE3U","error":"styles_error__2YcsZ"};